var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyrightIcoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 9.99992C3.33301 6.31802 6.31778 3.33325 9.99967 3.33325C13.6816 3.33325 16.6663 6.31802 16.6663 9.99992C16.6663 13.6818 13.6816 16.6666 9.99967 16.6666C6.31778 16.6666 3.33301 13.6818 3.33301 9.99992Z",
    stroke: "#ADADAD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 12.4447C10.983 12.5874 10.5965 12.6666 10.1902 12.6666C8.61219 12.6666 7.33301 11.4727 7.33301 9.99992C7.33301 8.52716 8.61219 7.33325 10.1902 7.33325C10.5965 7.33325 10.983 7.41242 11.333 7.55514",
    stroke: "#ADADAD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyrightIcoWhite);
export default __webpack_public_path__ + "static/media/copyright-ico-white.9ff9cf5ac8ad0a28ad144c9b8d91171d.svg";
export { ForwardRef as ReactComponent };